export default __webpack_public_path__ + "static/media/bfcBuyerTransportation.e9f53829.svg";